export class DateUtil {
  public static createFromApi(response: undefined | null | string): Date | null {
    if (!response) {
      return null;
    }
    const dateFromResponse = new Date(response);
    if (isNaN(dateFromResponse as unknown as number)) {
      return null;
    }
    return dateFromResponse;
  }

  public static createOrInitialise(response: undefined | null | string): Date {
    const result = DateUtil.createFromApi(response);
    if (result === null) {
      return new Date();
    }
    return result;
  }
}
